export const MaxImageSize = {
  Common: 3000000,
};

export const FileTypes = {
  types: ['pdf'],
};
